import { render } from "./t3.vue?vue&type=template&id=78fbf5f0&scoped=true"
import script from "./t3.vue?vue&type=script&lang=js"
export * from "./t3.vue?vue&type=script&lang=js"

import "./t3.vue?vue&type=style&index=0&id=78fbf5f0&scoped=true&lang=css"

import exportComponent from "D:\\网页文件\\新闻网专题\\2023ZT\\Fzsp\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fbf5f0"]])

export default __exports__